import * as actionTypes from './actionTypes';

export function changeBusinessAppRedirection(isBusinessAppRedirection) {
  return { type: actionTypes.SET_BUSINESS_APP_REDIRECTION, isBusinessAppRedirection };
}

export function setBusinessAppRedirection(isBusinessAppRedirection) {
  return dispatch => dispatch(changeBusinessAppRedirection(isBusinessAppRedirection));
}

export function changeTseuFlagRedirection(isTseu) {
  return { type: actionTypes.SET_TSEU_FLAG_REDIRECTION, isTseu };
}

export function setTseuFlagRedirection(isTseu) {
    return dispatch => dispatch(changeTseuFlagRedirection(isTseu));
}
